export const SIGNUP_INVITE_ONLY_MESSAGE = 'Sign-ups are currently invite-only.';
export const SIGNUP_INVITE_ONLY_ERROR_CODE = 'SignupInviteOnly';

type SignupGateEnv = NodeJS.ProcessEnv | { SIGNUPS_ENABLED?: string };

export class SignupDisabledError extends Error {
  constructor(message = SIGNUP_INVITE_ONLY_MESSAGE) {
    super(message);
    this.name = 'SignupDisabledError';
  }
}

export function isSignupEnabled(env: SignupGateEnv = process.env) {
  return env.SIGNUPS_ENABLED !== 'false';
}

export function assertSignupEnabled(env?: SignupGateEnv) {
  if (!isSignupEnabled(env)) {
    throw new SignupDisabledError();
  }
}
